import { render, staticRenderFns } from "./NewMessageThread.vue?vue&type=template&id=9ccdcfd0&scoped=true"
import script from "./NewMessageThread.vue?vue&type=script&lang=js"
export * from "./NewMessageThread.vue?vue&type=script&lang=js"
import style0 from "./NewMessageThread.vue?vue&type=style&index=0&id=9ccdcfd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccdcfd0",
  null
  
)

export default component.exports